import firebase from "firebase/app";

const state = {
  patients: {},
  active_patients: {},
  download_games_count: {},
  patient: {},
  error: null
};

const getters = {
  getPatients(state) {
    return state.patients;
  },
  getSumDownloadGamesCount(state) {
    let sum = 0;

    state.patients.forEach(function(item) {
      if (item.game_info[1].fcm_token != "...") {
        sum++;
      }
      if (item.game_info[2].fcm_token != "...") {
        sum++;
      }
      if (item.game_info[3].fcm_token != "...") {
        sum++;
      }
      if (item.game_info[4].fcm_token != "...") {
        sum++;
      }
    });

    return sum;
  },
  getDownloadGamesCount(state) {
    const returnArr = [];
    //let sum = 0;
    let ball_count = 0;
    let spider_count = 0;
    let crosses_count = 0;
    let puzzle_count = 0;

    state.patients.forEach(function(item) {
      if (item.game_info[1].fcm_token != "...") {
        ball_count++;
        //sum++;
      }
      if (item.game_info[2].fcm_token != "...") {
        spider_count++;
        // sum++;
      }
      if (item.game_info[3].fcm_token != "...") {
        crosses_count++;
        //sum++;
      }
      if (item.game_info[4].fcm_token != "...") {
        puzzle_count++;
      }
    });

    returnArr[0] = ball_count;
    returnArr[1] = spider_count;
    returnArr[2] = crosses_count;
    returnArr[3] = puzzle_count;

    return returnArr;
  },
  getActivePatients(state) {
    const returnArr = {};
    state.patients.forEach(function(item) {
      if (!item.disabled) {
        returnArr.push(item);
      }
    });
    return returnArr;
  },
  getPatient(state) {
    return state.patient;
  },
  getActivePatientCount(state) {
    let count = 0;
    state.patients.forEach(function(item) {
      if (!item.disabled) {
        count++;
      }
    });
    return count;
  },
  getPatientCount(state) {
    return state.patients.length;
  },
  getError(state) {
    return state.error;
  }
};

const mutations = {
  setPatients(state, payload) {
    state.patients = payload;
  },
  setPatient(state, payload) {
    state.patient = payload;
  },
  setError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  async updatePatient({ commit }, gamer) {
    try {
      await firebase
        .database()
        .ref(`/gamers`)
        .child(gamer.id)
        .update(gamer);
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },
  async deletePatient({ commit }, gamer) {
    try {
      await firebase
        .database()
        .ref(`/gamers`)
        .child(gamer.id)
        .remove();
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },
  async fetchPatient({ commit }) {
    try {
      const gamers =
        (
          await firebase
            .database()
            .ref(`/gamers`)
            .once("value")
        ).val() || {};
      return Object.keys(gamers).map(key => ({ ...gamers[key], id: key }));
    } catch (e) {
      commit("setError", e);
      throw e;
    }
  },
  async fetchPatientById({ commit }, id) {
    const patient = firebase
      .database()
      .ref(`/gamers`)
      .child(id)
      .once("value", snapshot => {
        commit("setPatient", snapshot.val() || {});
      })
      .catch(error => {
        commit("setError", error);
      });
    return patient;
  },
  async fetchPatientsByDoctorId({ commit }, doctor_id) {
    firebase
      .database()
      .ref(`/gamers`)
      .orderByChild("doctor_id")
      .equalTo(doctor_id)
      .once("value", snapshot => {
        const returnArr = [];
        snapshot.forEach(function(childSnapshot) {
          const item = childSnapshot.val();
          returnArr.push(item);
        });
        returnArr.sort(function(a, b) {
          return b.create_date - a.create_date;
        });
        commit("setPatients", returnArr);
      })
      .catch(error => {
        commit("setError", error);
      });
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
